<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>Forgot Password</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>Forgot Password</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="login-area pt-100 col-lg-3 mx-auto">
    <div class="container">
        <h2>Reset Your Password</h2>

        <!-- ✅ Show success message + link to login -->
        <div *ngIf="formSubmitted">
            <div class="alert alert-success">
                {{ successMessage }}
            </div>
            <div class="text-center mt-3">
                <a routerLink="/login" class="btn btn-primary">Go to Login</a>
            </div>
        </div>

        <!-- ✅ Hide form after success -->
        <form *ngIf="!formSubmitted" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
            <div *ngIf="successMessage" class="alert alert-success">
                {{ successMessage }}
            </div>
            <div *ngIf="errorMessage" class="alert alert-danger">
                {{ errorMessage }}
            </div>
            <div class="form-group">
                <input type="email" class="form-control" placeholder="Email" formControlName="email">
                <div *ngIf="forgotPasswordForm.get('email').errors && forgotPasswordForm.get('email').touched" class="alert alert-danger">
                    Email is required and must be a valid email.
                </div>
            </div>

            <div class="text-center">
                <button type="submit" class="btn create-ac-btn" [disabled]="forgotPasswordForm.invalid || isSubmitting">
                    {{ isSubmitting ? 'Submitting...' : 'Submit' }}
                </button>
            </div>
        </form>
    </div>
</div>
